import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import LazyImg from '@/components/base/LazyImg';
import Linker from '@/components/base/Linker';
import { makeDAppAddress } from '@/utils/link';
import { DEFAULT } from '@/constants';
export default function DAppMiniCard(props) {
    var _url = props.url, url = _url === void 0 ? '' : _url, confirmed = props.confirmed, chainid = props.chainid, _name = props.name, name = _name === void 0 ? '--' : _name, _className = props.className, className = _className === void 0 ? '' : _className, address = props.address;
    return(/*#__PURE__*/ _jsxs(Linker, {
        href: makeDAppAddress(address),
        className: "flex flex-col items-center justify-between rounded-[4px] bg-white p-[24px] cursor-pointer ".concat(className),
        children: [
            /*#__PURE__*/ _jsx(LazyImg, {
                url: url,
                className: "w-[64px] h-[64px] rounded-full",
                defaultUrl: DEFAULT.DAPP_ICON,
                alt: "dapp-logo"
            }),
            /*#__PURE__*/ _jsx("h5", {
                className: "text-[15px] w-full text-center text-base leading-[18px] line-clamp",
                children: name
            }),
            confirmed === true ? /*#__PURE__*/ _jsx("p", {
                className: "text-green",
                children: "Confirmed"
            }) : /*#__PURE__*/ _jsxs("p", {
                className: "text-[#6A7394]",
                children: [
                    "#",
                    chainid
                ]
            })
        ]
    }));
};
